import React, { useContext } from 'react';

import { ActionBar, Actions, Action } from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { SearchField } from '@gogame/screens';

import SwitchViewMode from 'scenes/Gallery/components/SwitchViewMode';

import { VIEW_MODE_TILES } from 'scenes/Gallery/ConversionPages/constants';
import { ConversionGroupsDataTableContext } from 'scenes/Gallery/ConversionPages/ConversionGroups/ConversionGroupsDataTable';

import OrderControl from './OrderControl';

const Toolbar = ({ tabs }) => {
  const { viewMode, setViewMode } = useContext(
    ConversionGroupsDataTableContext
  );

  return (
    <ActionBar
      search={<SearchField tooltip={'Search by id, name or tag'} />}
      secondaryActions={
        <Actions>
          {viewMode === VIEW_MODE_TILES ? (
            <Action custom={<OrderControl />} />
          ) : null}
          <Action component={FullScreenToggler} />
        </Actions>
      }
      modeSwitcher={
        <Actions>
          <Action
            custom={
              <SwitchViewMode viewMode={viewMode} setViewMode={setViewMode} />
            }
          />
        </Actions>
      }
    >
      {tabs}
    </ActionBar>
  );
};

export default Toolbar;
